module.exports = __webpack_public_path__ + "img/xcl.031dc4f.png";